import { Checkbox } from "src/components/MuiGenerals";
import { useBatchApproveAllowanceFormContext } from "../../../contexts";

function PreparedAddressesCheckbox() {
  const {
    fields: { isPreparedAddresses },
    setFields,
    translate: t,
  } = useBatchApproveAllowanceFormContext();

  return (
    <>
      <span>{t("prepared_addresses")}</span>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          height: "100%",
        }}
      >
        <Checkbox
          checked={isPreparedAddresses}
          onChange={(e) =>
            setFields((f: any) => {
              return {
                ...f,
                isPreparedAddresses: e.target.checked,
                threshold: e.target.checked ? "0" : "",
              };
            })
          }
        />
      </div>
    </>
  );
}

export default PreparedAddressesCheckbox;
